import { render, staticRenderFns } from "./BuyingInfoWholesaleAnalysis.vue?vue&type=template&id=67016d4b&scoped=true&"
import script from "./BuyingInfoWholesaleAnalysis.vue?vue&type=script&lang=js&"
export * from "./BuyingInfoWholesaleAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./BuyingInfoWholesaleAnalysis.vue?vue&type=style&index=0&id=67016d4b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67016d4b",
  null
  
)

export default component.exports